import { Fragment, useEffect, useState } from "react";
import { DashboardHeader } from "../components/top-bar/Dashboard-header";
import { Card, Col, message, Row, Spin } from "antd";
import { RegistrationPerEventView } from "../components/cross-sales/RegistrationPerEvent";
import { CrossSalesRevenue } from "../components/cross-sales/Cross-Sales-Revenue";
import dayjs from "dayjs";
import { useGetDashboardCrossSummary } from "../use-cases/get-crossssles-summary";
import { DashboardApiService } from "../api/dashboard-api.services";
import cash from 'assets/Dashboard/Money.svg'
import { crossshop } from "components/side-bar/utils";
import { useUserContext } from "features/users";
export const RegistrationCrossSalesView = () => {
    const today = dayjs();
    const [selectedYear, setSelectedYear] = useState<number>(today.year());
    const [selectedEvent, setSelectedEvent] = useState<string | undefined>();
    const [selectedCategory, setSelectedCategory] = useState<string | undefined>();
    const [dateRange, setDateRange] = useState<[dayjs.Dayjs, dayjs.Dayjs] | null>('' as any);
    const [registrationData, setRegistrationData] = useState<any>(null);
    const { user } = useUserContext()

    // 🔹 Common filter params
    const commonParams = {
        FromDate: dateRange?.[0]?.format("YYYY-MM-DD") || "",
        ToDate: dateRange?.[1]?.format("YYYY-MM-DD") || "",
        Year: selectedYear || "",
        EventId: selectedEvent || "",
        CategoryId: selectedCategory || "",
        AgentId: user?.user_id

    };

    // 🔹 Query hook (summary API)
    const { data: summary, isFetching: summaryIsfetching } = useGetDashboardCrossSummary(commonParams);
    // ✅ Ensure safe access
    const firstValue = Array.isArray(summary?.Values) ? summary.Values[0] : null;

    const transformedValues = [
        {
            label: "T-shirt Printing",
            value: firstValue?.TShirtPrinting ?? 0,
            icon: cash,
        },
        {
            label: "Medal Engraving",
            value: firstValue?.MedalEngraving ?? 0,
            icon: cash,
        },
        {
            label: "Delivery",
            value: firstValue?.Delivery ?? 0,
            icon: cash,
        },
        {
            label: "Insurance",
            value: firstValue?.Insurance ?? 0,
            icon: cash,
        },
        {
            label: "Total Cross Sales",
            value: firstValue?.TotalCrossSales ?? 0,
            icon: cash,
        },
    ];

    // 🔹 Manual fetch (registration cross sales API)
    const fetchRegistrationData = async () => {
        try {
            const response = await DashboardApiService().getDashboardregistrationcrosssales(commonParams);
            setRegistrationData(response);
        } catch (error: any) {
            message.error(error?.message || "Failed to load registration data");
        }
    };

    // 🔹 Refetch whenever filters change
    useEffect(() => {
        fetchRegistrationData();
    }, [JSON.stringify(commonParams)]); // depend on params safely


    return (
        <Fragment>
            {/* 🔹 Filters */}
            <DashboardHeader
                setDateRange={setDateRange}
                setSelectedYear={setSelectedYear}
                selectedYear={selectedYear}
                dateRange={dateRange}
                setSelectedEvent={setSelectedEvent}
                setSelectedCategory={setSelectedCategory}
                selectedEvent={selectedEvent}
                selectedCategory={selectedCategory}
                year={selectedYear}
            />
            {/* 🔹 Summary Cards */}
            <Row gutter={[16, 16]} className="stats_bx row_gap respn_row">
                {transformedValues.map((item, index) => (
                    <Col span={5} key={index}>
                        <div className="sales_regis">
                            <Spin spinning={summaryIsfetching}>
                                <Card
                                    style={{
                                        backgroundColor: crossshop[item.label] || "#fff",
                                    }}

                                >
                                    <>


                                        <p style={{ fontSize: 14, color: "#fff" }}>{item.label}</p>

                                        <div className="card_img_t">
                                            <h2 style={{ fontSize: 14, color: "#fff" }}>KWD {item.value}</h2>
                                            <img src={item.icon} alt={item.label} width={40} height={40} />
                                        </div>
                                    </>
                                </Card>
                            </Spin>
                        </div>
                    </Col>
                ))}
            </Row>

            {/* 🔹 Charts */}
            <Row gutter={[16, 16]} className="row-graph row_gap">
                <Col span={24}>
                    <RegistrationPerEventView data={registrationData} />
                </Col>
                <Col span={12} className="respn_col">
                    <Spin spinning={summaryIsfetching}> <CrossSalesRevenue data={summary} /></Spin>
                </Col>
            </Row>
        </Fragment>
    );
};
